import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import PayrollService from '../../services/PayrollService';

const initialState = {
    data: {},
    columnConfig: [],
    status: 'idle',
    formData: {
        workWeek: [],
        payScheduleList: [],
        usersList: [],
        userWithTeams: [],
        userWithExpenseGroup:[],
        teams:[]
    }
};

export const fetchPayrolls = createAsyncThunk('payroll', async () => {
    const response = await PayrollService.getPayrollByPage();
    return response;
});

export const fetchWorkWeeks = createAsyncThunk('workweek', async () => {
    const response = await PayrollService.getTenantWorkWeek();
    return response;
});

export const fetchPayschedules = createAsyncThunk('payschedule', async () => {
    let response = {};
    if(PayrollService?.payscheduleFilterArray?.length > 0) {
        response = await PayrollService.getFilteredPayScheduleList();
    } else {
        response = await PayrollService.getPayScheduleList();
    }
    
    return response;
});

export const fetchUsers = createAsyncThunk('users', async () => {
    const response = await PayrollService.getUsersList();
    return response;
});
export const fetchUsersListWithTeams = createAsyncThunk('userTeams', async () => {
    const response = await PayrollService.getUsersListWithTeams();
    return response;
});

export const fetchUsersExpenseGroup = createAsyncThunk('userExpenseGroup', async () => {
    const response = await PayrollService.getUsersExpenseGroup();
    return response;
});

export const fetchFilteredPayrolls = createAsyncThunk('filtered-payroll', async () => {
    const response = await PayrollService.getFilteredPayrollByPage();
    return response;
});

export const fetchFilteredPayschedules = createAsyncThunk('filtered-payschedules', async () => {
    const response = await PayrollService.getFilteredPayScheduleList();
    return response;
});

export const fetchTeams = createAsyncThunk('teams', async () => {
    const response = await PayrollService.getTeams();
    return response;
});

export const PayrollSlice = createSlice({
    name: 'payroll',
    initialState,
    reducers: {
        addPayrollColumnConfig: (state, action) => {
            const configs = action.payload;
            let configsToStore = [];
            configs.forEach((config) => {
                configsToStore.push({
                    ...config,
                    key: config.columnCode,
                    options: config.options ? config.options : []
                });
            });
            state.columnConfig = configsToStore;
        },
        addColumnToPayrollColumnConfig: (state, action) => {
            state.columnConfig = [...state.columnConfig, action.payload];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPayrolls.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchPayrolls.fulfilled, (state, action) => {
                state.status = 'idle';
                state.data = action.payload;
            })
            .addCase(fetchWorkWeeks.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchWorkWeeks.fulfilled, (state, action) => {
                state.status = 'idle';
                state.formData.workWeek = action.payload;
            })
            .addCase(fetchPayschedules.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchPayschedules.fulfilled, (state, action) => {
                state.status = 'idle';
                state.formData.payScheduleList = action.payload;
            })
            .addCase(fetchUsers.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchUsers.fulfilled, (state, action) => {
                state.status = 'idle';
                state.formData.usersList = action.payload;
            })
            .addCase(fetchFilteredPayrolls.pending,(state, action) => {
                state.status = 'loading';
            })
            .addCase(fetchFilteredPayrolls.fulfilled, (state, action) => {
                state.status = 'idle';
                state.data = action.payload;
            })
            .addCase(fetchFilteredPayschedules.pending,(state, action) => {
                state.status = 'loading';
            })
            .addCase(fetchFilteredPayschedules.fulfilled, (state, action) => {
                state.status = 'idle';
                state.formData.payScheduleList = action.payload;
            })
            .addCase(fetchUsersListWithTeams.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchUsersListWithTeams.fulfilled, (state, action) => {
                state.status = 'idle';
                state.formData.userWithTeams = action.payload;
            })
            .addCase(fetchUsersExpenseGroup.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchUsersExpenseGroup.fulfilled, (state, action) => {
                state.status = 'idle';
                state.formData.userWithExpenseGroup = action.payload;
            })
            .addCase(fetchTeams.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchTeams.fulfilled, (state, action) => {
                state.status = 'idle';
                state.formData.teams = action.payload;
            })
    }
});

export const { addPayrollColumnConfig, addColumnToPayrollColumnConfig } =
    PayrollSlice.actions;

export const selectPayroll = (state) => state.payroll.data;

export const selectPayrollColumnConfig = (state) =>
    state.payroll.columnConfig;

export const selectWorkweeks = (state) =>
    state.payroll.formData.workWeek;

export const selectPaySchedule = (state) =>
    state.payroll.formData.payScheduleList;

export const selectUsers = (state) =>
    state.payroll.formData.usersList;

export const selectUserWithTeams = (state) =>
    state.payroll.formData.userWithTeams;

export const selectUserExpenseGroup = (state) =>
    state.payroll.formData.userWithExpenseGroup;
export const selectTeams = (state) =>
    state.payroll.formData.teams

export default PayrollSlice.reducer;